import React from 'react';

// Create a context for the dashboard with a default value
const DashboardContext = React.createContext({
  activeTab: '' // Default value for activeTab
});

export default DashboardContext; 